import "./Icons.css"
const Icons = function (props) {
    if(props.layout == "first"){
        return (<a href={props.data.ModLinksLink.NavigateUrl} title={props.data.Title} className="IconLink col-3">
                <div className="iconsBG LinkItem " >
                    <div className="LinkItemTitle">{props.data.Title}</div>
                    <img src={props.data.ModDTImage_Url+ (props.mobile? "?RenditionId=7" : "?RenditionId=8")} className="img-fluid mx-auto d-block" alt=''/>
                    <div className="yellowCorner"/>
                </div>
            </a>);
    }
    else if(props.layout == "second"){
        return (<div className="iconItem col-6 col-md-3" >
            <a href={props.data.ModLinksLink.NavigateUrl}>
                <div className="card">
                    <div className="imgWrap">
                        <img src={props.data.ModDTImage_Url + (props.mobile ? "": "?RenditionId=5")} className="img-fluid mx-auto d-block" alt={props.data.Title}/>
                    </div>
                    <div className="card-body">
                        <div className="card-text" >{props.data.Title}</div>
                    </div>
                </div>
            </a>
        </div>);
    }
    else{ //props.layout == "third"
        const styleIcon = props.mobile || (props.amount && props.amount) == 4 ? {} : {maxWidth: (100/props.amount).toString()+"%"};
        return (<a href={props.data.ModLinksLink.NavigateUrl} title={props.data.Title} className={"IconLink col-6 col-md-3"} style={ styleIcon }>
                <div className="iconsBG LinkItem " >
                    <div className="LinkItemTitle">{props.data.Title}</div>
                    <img src={props.data.ModDTImage_Url+ (props.mobile? "?RenditionId=6" : "")} className="img-fluid mx-auto d-block" alt=''/>
                    <div className="yellowCorner"/>
                </div>
            </a>);
    }
}
export default Icons;
